var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hide)?_c('div',[_c('b-card',[(_vm.chartOptions.xaxis.categories && this.series[0].data)?_c('apex-chart',{attrs:{"type":"bar","height":"350","options":_vm.chartOptions,"series":_vm.series}}):_c('b-spinner',{attrs:{"label":"Loading..."}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }